import {
  SET_COMMON_DASHBOARD_APPS,
  SET_ADD_APP_FAV,
  SET_LOADING,
  SET_NEWS_AND_ANNOUNCEMENT,
  SET_ATTACHMENTS,
  TOGGLE_ATTACHMENTS_LOADING,
  REMOVE_ATTACHMENT,
  GLOBAL_LOADER_TEXT,
} from "./types";

const initialState = {
  commonPortalApps: { favoriteApplication: [], applications: [] },
  addFavApps: false,
  loading: false,
  NewsAndAnnouncementDetails: [{}],
  globalLoaderTxt: "",
  attachments: {
    loading: false,
    list: [],
  },
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_COMMON_DASHBOARD_APPS:
      return {
        ...state,
        commonPortalApps: action.value,
      };
    case SET_ADD_APP_FAV:
      return {
        ...state,
        addFavApps: !state.addFavApps,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    case SET_NEWS_AND_ANNOUNCEMENT:
      const NewsAndAnnouncementDetails = action.value;
      return {
        ...state,
        NewsAndAnnouncementDetails,
      };
    case SET_ATTACHMENTS:
      const fileList = action.value;
      return {
        ...state,
        attachments: {
          ...state.attachments,
          list: [...state.attachments.list, ...fileList],
        },
      };
    case TOGGLE_ATTACHMENTS_LOADING:
      return {
        ...state,
        attachments: {
          ...state.attachments,
          loading: action.value,
        },
      };
    case REMOVE_ATTACHMENT:
      const index = action.value;
      const newArr = state.attachments.list.slice();
      newArr.splice(index, 1);
      return {
        ...state,
        attachments: {
          ...state.attachments,
          list: [...newArr],
        },
      };
    case GLOBAL_LOADER_TEXT:
      return {
        ...state,
        globalLoaderTxt: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
